<div class="apt-page">

  <div class="apt-header">
    <div>
      <h1 class="apt-title">Project Types</h1>
      <p class="apt-subtitle">{{ types.length }} type{{ types.length !== 1 ? 's' : '' }} configured</p>
    </div>
  </div>

  <!-- Add new type -->
  <div class="apt-add-card">
    <mat-form-field appearance="outline" class="apt-add-field">
      <mat-label>New project type</mat-label>
      <mat-icon matPrefix>add_circle_outline</mat-icon>
      <input matInput [(ngModel)]="newTypeName" (keyup.enter)="submitAdd()" placeholder="e.g. Remodel, New Build, Repair…">
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="submitAdd()" [disabled]="adding || !newTypeName.trim()">
      <mat-icon>add</mat-icon> {{ adding ? 'Adding…' : 'Add Type' }}
    </button>
    <div class="apt-error" *ngIf="addError">{{ addError }}</div>
  </div>

  <!-- Error -->
  <div class="apt-error apt-error--page" *ngIf="error">
    {{ error }}
    <button mat-button color="warn" (click)="load()">Retry</button>
  </div>

  <!-- Loading -->
  <div class="apt-skeleton" *ngIf="isLoading">
    <div class="sk-row" *ngFor="let i of [1,2,3,4]">
      <div class="sk-pill"></div>
      <div class="sk-actions"></div>
    </div>
  </div>

  <!-- Empty -->
  <div class="apt-empty" *ngIf="!isLoading && types.length === 0 && !error">
    <mat-icon>category</mat-icon>
    <p>No project types yet. Add your first one above.</p>
  </div>

  <!-- Type list -->
  <div class="apt-list" *ngIf="!isLoading && types.length > 0">
    <div class="apt-row" *ngFor="let t of types">

      <!-- View mode -->
      <ng-container *ngIf="editingId !== t.id && deletingId !== t.id">
        <span class="apt-name">{{ t.type }}</span>
        <div class="apt-actions">
          <button mat-icon-button (click)="startEdit(t)" matTooltip="Rename">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="confirmDelete(t)" matTooltip="Delete">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </ng-container>

      <!-- Edit mode -->
      <ng-container *ngIf="editingId === t.id">
        <input class="apt-edit-input" [(ngModel)]="editingName"
               (keyup.enter)="saveEdit(t)" (keyup.escape)="cancelEdit()" autofocus>
        <div class="apt-actions">
          <button mat-icon-button color="primary" (click)="saveEdit(t)" [disabled]="saving" matTooltip="Save">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button (click)="cancelEdit()" matTooltip="Cancel">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </ng-container>

      <!-- Delete confirm -->
      <ng-container *ngIf="deletingId === t.id">
        <span class="apt-name apt-name--deleting">Delete "{{ t.type }}"?</span>
        <div class="apt-actions">
          <button mat-raised-button color="warn" (click)="doDelete(t)">Delete</button>
          <button mat-stroked-button (click)="cancelDelete()">Cancel</button>
        </div>
      </ng-container>

    </div>
  </div>

</div>
